import { getGlobal } from "./GlobalUtil";

export default class StringUtil {
  static hashcode(str: string): number {
    return str
      .split("")
      .reduce(
        (prevHash, currVal) =>
          ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
        0
      );
  }

  static commafy(num) {
    if (!num) return "0";
    return num.toLocaleString();
  }

  static addressSearchTextValidate(address: string) {
    if (address.length > 1) {
      //특수문자 제거
      var expText = /[%=><]/;
      if (expText.test(address) == true) {
        address = address.split(expText).join("");
        return false;
      }

      //특정문자열(sql예약어의 앞뒤공백포함) 제거
      var sqlArray = new Array(
        //sql 예약어
        "OR",
        "SELECT",
        "INSERT",
        "DELETE",
        "UPDATE",
        "CREATE",
        "DROP",
        "EXEC",
        "UNION",
        "FETCH",
        "DECLARE",
        "TRUNCATE"
      );

      var regex;
      for (var i = 0; i < sqlArray.length; i++) {
        regex = new RegExp(sqlArray[i], "gi");

        if (regex.test(address)) {
          // alert("\"" + sqlArray[i]+"\"와(과) 같은 특정문자로 검색할 수 없습니다.");
          address = address.replace(regex, "");
          return false;
        }
      }

      return true;
    }

    return false;
  }

  static isEncodeFilePath(address: string) {
    let filePath = getGlobal("jsonFilePath", true);
    if (!filePath) return false;
    let keys = Object.keys(filePath);
    for (let i = 0; i < keys.length; i++) {
      if (address.startsWith(keys[i])) {
        return true;
      }
    }
  }

  static createStringFromTemplate(template, variables): string {
    return template.replace(
      new RegExp("#{([^{]+)}", "g"),
      function (_unused, varName) {
        if (variables[varName] || variables[varName] == "")
          return variables[varName];
        return "#{" + varName + "}";
      }
    );
  }

  static isNumericString(str) {
    return /^\d+[\.]?[\d]*$/.test(str);
  }

  static getPhoneNumberString(phone: string) {
    if (!phone) return "";
    phone = phone.replace(/-/gi, "");
    phone =
      phone.substring(0, 3) +
      "-" +
      phone.substring(3, 7) +
      "-" +
      phone.substring(7);
    return phone;
  }
}

export const getByteSize = (size: number) => {
  const byteUnits = ["KB", "MB", "GB", "TB"];

  for (let i = 0; i < byteUnits.length; i++) {
    size = Math.floor(size / 1024);

    if (size < 1024) return `${size.toFixed(0)} ${byteUnits[i]}`;
  }
};

const filePath = {
  "&&&": process.env.REACT_APP_YMYD_ADDRESS,
  "@@@": process.env.REACT_APP_DEV_STORAGE_ADDRESS,
  "###": process.env.REACT_APP_STG_STORAGE_ADDRESS,
};

export const convertFilePath = (address: string) => {
  if (!address) return "";
  let keys = Object.keys(filePath);
  for (let i = 0; i < keys.length; i++) {
    if (address.startsWith(keys[i])) {
      address = address.replace(keys[i], filePath[keys[i]]);
      break;
    }
  }

  return address;
};

export const convertFilePathFull = (longText: string) => {
  if (!longText) return "";
  let keys = Object.keys(filePath);
  for (let i = 0; i < keys.length; i++) {
    longText = longText.replace(new RegExp(keys[i], "gi"), filePath[keys[i]]);
  }

  return longText;
};

export const encodeFilePathFull = (longText: string) => {
  if (!longText) return "";
  let keys = Object.keys(filePath);
  for (let i = 0; i < keys.length; i++) {
    longText = longText.replace(new RegExp(filePath[keys[i]], "gi"), keys[i]);
  }

  return longText;
};
